import React from 'react';
import { SendFeedbackApi } from './SendFeedbackProvider';

// @ts-expect-errors
export const SendFeedbackContext = React.createContext<SendFeedbackApi>({});
